/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { TicketWorkOrderEventDto } from './TicketWorkOrderEventDto';
import {
    TicketWorkOrderEventDtoFromJSON,
    TicketWorkOrderEventDtoFromJSONTyped,
    TicketWorkOrderEventDtoToJSON,
    TicketWorkOrderEventDtoToJSONTyped,
} from './TicketWorkOrderEventDto';
import type { TicketVisitReportDto } from './TicketVisitReportDto';
import {
    TicketVisitReportDtoFromJSON,
    TicketVisitReportDtoFromJSONTyped,
    TicketVisitReportDtoToJSON,
    TicketVisitReportDtoToJSONTyped,
} from './TicketVisitReportDto';

/**
 * 
 * @export
 * @interface MaintenanceTicketDetailDto
 */
export interface MaintenanceTicketDetailDto {
    /**
     * 
     * @type {string}
     * @memberof MaintenanceTicketDetailDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof MaintenanceTicketDetailDto
     */
    code: string;
    /**
     * 
     * @type {string}
     * @memberof MaintenanceTicketDetailDto
     */
    type: MaintenanceTicketDetailDtoTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof MaintenanceTicketDetailDto
     */
    status: MaintenanceTicketDetailDtoStatusEnum;
    /**
     * 
     * @type {boolean}
     * @memberof MaintenanceTicketDetailDto
     */
    needsFollowUp: boolean;
    /**
     * 
     * @type {string}
     * @memberof MaintenanceTicketDetailDto
     */
    priority: MaintenanceTicketDetailDtoPriorityEnum;
    /**
     * 
     * @type {string}
     * @memberof MaintenanceTicketDetailDto
     */
    title: string;
    /**
     * 
     * @type {object}
     * @memberof MaintenanceTicketDetailDto
     */
    assetId?: object | null;
    /**
     * 
     * @type {object}
     * @memberof MaintenanceTicketDetailDto
     */
    siteId?: object | null;
    /**
     * 
     * @type {Date}
     * @memberof MaintenanceTicketDetailDto
     */
    dueAt?: Date | null;
    /**
     * 
     * @type {object}
     * @memberof MaintenanceTicketDetailDto
     */
    description?: object | null;
    /**
     * 
     * @type {object}
     * @memberof MaintenanceTicketDetailDto
     */
    taskId?: object | null;
    /**
     * 
     * @type {object}
     * @memberof MaintenanceTicketDetailDto
     */
    preventivePlanId?: object | null;
    /**
     * 
     * @type {object}
     * @memberof MaintenanceTicketDetailDto
     */
    planCode?: object | null;
    /**
     * 
     * @type {object}
     * @memberof MaintenanceTicketDetailDto
     */
    planName?: object | null;
    /**
     * 
     * @type {object}
     * @memberof MaintenanceTicketDetailDto
     */
    incidentId?: object | null;
    /**
     * 
     * @type {object}
     * @memberof MaintenanceTicketDetailDto
     */
    incidentCode?: object | null;
    /**
     * 
     * @type {object}
     * @memberof MaintenanceTicketDetailDto
     */
    incidentTitle?: object | null;
    /**
     * 
     * @type {object}
     * @memberof MaintenanceTicketDetailDto
     */
    occurrenceKey?: object | null;
    /**
     * 
     * @type {object}
     * @memberof MaintenanceTicketDetailDto
     */
    dueReading?: object | null;
    /**
     * Ordered checklist names from the linked library Task (empty when none)
     * @type {Array<string>}
     * @memberof MaintenanceTicketDetailDto
     */
    subtaskNames: Array<string>;
    /**
     * All visits (memberships) for this ticket, newest execution first
     * @type {Array<TicketVisitReportDto>}
     * @memberof MaintenanceTicketDetailDto
     */
    visits: Array<TicketVisitReportDto>;
    /**
     * 
     * @type {Array<TicketWorkOrderEventDto>}
     * @memberof MaintenanceTicketDetailDto
     */
    events: Array<TicketWorkOrderEventDto>;
    /**
     * Active work order id for this ticket (when any)
     * @type {object}
     * @memberof MaintenanceTicketDetailDto
     */
    activeWorkOrderId?: object | null;
    /**
     * Active work order code for this ticket (when any)
     * @type {object}
     * @memberof MaintenanceTicketDetailDto
     */
    activeWorkOrderCode?: object | null;
    /**
     * Active work order status for this ticket (when any)
     * @type {string}
     * @memberof MaintenanceTicketDetailDto
     */
    activeWorkOrderStatus?: MaintenanceTicketDetailDtoActiveWorkOrderStatusEnum | null;
    /**
     * Hold reason when the active work order is currently ON_HOLD
     * @type {object}
     * @memberof MaintenanceTicketDetailDto
     */
    activeOnHoldReason?: object | null;
}


/**
 * @export
 */
export const MaintenanceTicketDetailDtoTypeEnum = {
    Preventive: 'PREVENTIVE',
    Curative: 'CURATIVE'
} as const;
export type MaintenanceTicketDetailDtoTypeEnum = typeof MaintenanceTicketDetailDtoTypeEnum[keyof typeof MaintenanceTicketDetailDtoTypeEnum];

/**
 * @export
 */
export const MaintenanceTicketDetailDtoStatusEnum = {
    Open: 'OPEN',
    InProgress: 'IN_PROGRESS',
    Closed: 'CLOSED',
    Cancelled: 'CANCELLED'
} as const;
export type MaintenanceTicketDetailDtoStatusEnum = typeof MaintenanceTicketDetailDtoStatusEnum[keyof typeof MaintenanceTicketDetailDtoStatusEnum];

/**
 * @export
 */
export const MaintenanceTicketDetailDtoPriorityEnum = {
    Low: 'LOW',
    Medium: 'MEDIUM',
    High: 'HIGH'
} as const;
export type MaintenanceTicketDetailDtoPriorityEnum = typeof MaintenanceTicketDetailDtoPriorityEnum[keyof typeof MaintenanceTicketDetailDtoPriorityEnum];

/**
 * @export
 */
export const MaintenanceTicketDetailDtoActiveWorkOrderStatusEnum = {
    Planned: 'PLANNED',
    Assigned: 'ASSIGNED',
    InProgress: 'IN_PROGRESS',
    OnHold: 'ON_HOLD',
    Completed: 'COMPLETED',
    Closed: 'CLOSED',
    Archived: 'ARCHIVED',
    Cancelled: 'CANCELLED'
} as const;
export type MaintenanceTicketDetailDtoActiveWorkOrderStatusEnum = typeof MaintenanceTicketDetailDtoActiveWorkOrderStatusEnum[keyof typeof MaintenanceTicketDetailDtoActiveWorkOrderStatusEnum];


/**
 * Check if a given object implements the MaintenanceTicketDetailDto interface.
 */
export function instanceOfMaintenanceTicketDetailDto(value: object): value is MaintenanceTicketDetailDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('code' in value) || value['code'] === undefined) return false;
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('needsFollowUp' in value) || value['needsFollowUp'] === undefined) return false;
    if (!('priority' in value) || value['priority'] === undefined) return false;
    if (!('title' in value) || value['title'] === undefined) return false;
    if (!('subtaskNames' in value) || value['subtaskNames'] === undefined) return false;
    if (!('visits' in value) || value['visits'] === undefined) return false;
    if (!('events' in value) || value['events'] === undefined) return false;
    return true;
}

export function MaintenanceTicketDetailDtoFromJSON(json: any): MaintenanceTicketDetailDto {
    return MaintenanceTicketDetailDtoFromJSONTyped(json, false);
}

export function MaintenanceTicketDetailDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): MaintenanceTicketDetailDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'code': json['code'],
        'type': json['type'],
        'status': json['status'],
        'needsFollowUp': json['needsFollowUp'],
        'priority': json['priority'],
        'title': json['title'],
        'assetId': json['assetId'] == null ? undefined : json['assetId'],
        'siteId': json['siteId'] == null ? undefined : json['siteId'],
        'dueAt': json['dueAt'] == null ? undefined : (new Date(json['dueAt'])),
        'description': json['description'] == null ? undefined : json['description'],
        'taskId': json['taskId'] == null ? undefined : json['taskId'],
        'preventivePlanId': json['preventivePlanId'] == null ? undefined : json['preventivePlanId'],
        'planCode': json['planCode'] == null ? undefined : json['planCode'],
        'planName': json['planName'] == null ? undefined : json['planName'],
        'incidentId': json['incidentId'] == null ? undefined : json['incidentId'],
        'incidentCode': json['incidentCode'] == null ? undefined : json['incidentCode'],
        'incidentTitle': json['incidentTitle'] == null ? undefined : json['incidentTitle'],
        'occurrenceKey': json['occurrenceKey'] == null ? undefined : json['occurrenceKey'],
        'dueReading': json['dueReading'] == null ? undefined : json['dueReading'],
        'subtaskNames': json['subtaskNames'],
        'visits': ((json['visits'] as Array<any>).map(TicketVisitReportDtoFromJSON)),
        'events': ((json['events'] as Array<any>).map(TicketWorkOrderEventDtoFromJSON)),
        'activeWorkOrderId': json['activeWorkOrderId'] == null ? undefined : json['activeWorkOrderId'],
        'activeWorkOrderCode': json['activeWorkOrderCode'] == null ? undefined : json['activeWorkOrderCode'],
        'activeWorkOrderStatus': json['activeWorkOrderStatus'] == null ? undefined : json['activeWorkOrderStatus'],
        'activeOnHoldReason': json['activeOnHoldReason'] == null ? undefined : json['activeOnHoldReason'],
    };
}

export function MaintenanceTicketDetailDtoToJSON(json: any): MaintenanceTicketDetailDto {
    return MaintenanceTicketDetailDtoToJSONTyped(json, false);
}

export function MaintenanceTicketDetailDtoToJSONTyped(value?: MaintenanceTicketDetailDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'code': value['code'],
        'type': value['type'],
        'status': value['status'],
        'needsFollowUp': value['needsFollowUp'],
        'priority': value['priority'],
        'title': value['title'],
        'assetId': value['assetId'],
        'siteId': value['siteId'],
        'dueAt': value['dueAt'] == null ? value['dueAt'] : value['dueAt'].toISOString(),
        'description': value['description'],
        'taskId': value['taskId'],
        'preventivePlanId': value['preventivePlanId'],
        'planCode': value['planCode'],
        'planName': value['planName'],
        'incidentId': value['incidentId'],
        'incidentCode': value['incidentCode'],
        'incidentTitle': value['incidentTitle'],
        'occurrenceKey': value['occurrenceKey'],
        'dueReading': value['dueReading'],
        'subtaskNames': value['subtaskNames'],
        'visits': ((value['visits'] as Array<any>).map(TicketVisitReportDtoToJSON)),
        'events': ((value['events'] as Array<any>).map(TicketWorkOrderEventDtoToJSON)),
        'activeWorkOrderId': value['activeWorkOrderId'],
        'activeWorkOrderCode': value['activeWorkOrderCode'],
        'activeWorkOrderStatus': value['activeWorkOrderStatus'],
        'activeOnHoldReason': value['activeOnHoldReason'],
    };
}

